import React, { useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Music, Settings, Users, CheckCircle, ArrowRight, ArrowLeft, Clock, Home, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';
const STEPS = [{
  id: 1,
  title: 'Basic Info'
}, {
  id: 2,
  title: 'Requirements'
}, {
  id: 3,
  title: 'Constraints'
}, {
  id: 4,
  title: 'Review'
}];
export function EventNeedNewPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const nextStep = () => setCurrentStep(prev => Math.min(prev + 1, 4));
  const prevStep = () => setCurrentStep(prev => Math.max(prev - 1, 1));
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-4xl mx-auto space-y-6" data-id="element-3372">
      <div className="flex items-center justify-between" data-id="element-3373">
        <div data-id="element-3374">
          <h1 className="text-2xl font-bold text-zinc-100" data-id="element-3375">
            Create Event Need
          </h1>
          <p className="text-zinc-400" data-id="element-3376">
            Define what you're looking for to generate artist matches.
          </p>
        </div>
        <Link to="/app/event-needs" className="text-sm text-zinc-400 hover:text-zinc-100 transition-colors" data-id="element-3377">
          Cancel
        </Link>
      </div>

      {/* Progress Bar */}
      <div className="flex items-center justify-between mb-8" data-id="element-3378">
        {STEPS.map((step, index) => <Fragment key={step.id} data-id="element-3379">
            <div className="flex flex-col items-center" data-id="element-3380">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium mb-2 transition-colors ${currentStep > step.id ? 'bg-green-500 text-zinc-900' : currentStep === step.id ? 'bg-amber-500 text-zinc-900' : 'bg-zinc-800 text-zinc-500'}`} data-id="element-3381">
                {currentStep > step.id ? <CheckCircle className="w-5 h-5" data-id="element-3382" /> : step.id}
              </div>
              <span className={`text-xs font-medium ${currentStep >= step.id ? 'text-zinc-100' : 'text-zinc-500'}`} data-id="element-3383">
                {step.title}
              </span>
            </div>
            {index < STEPS.length - 1 && <div className={`flex-1 h-px mx-4 ${currentStep > step.id ? 'bg-green-500' : 'bg-zinc-800'}`} data-id="element-3384" />}
          </Fragment>)}
      </div>

      <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-8 min-h-[400px] flex flex-col" data-id="element-3385">
        <div className="flex-1" data-id="element-3386">
          {currentStep === 1 && <div className="space-y-6 max-w-2xl" data-id="element-3387">
              <h2 className="text-xl font-bold text-zinc-100" data-id="element-3388">
                Basic Event Info
              </h2>
              <div className="space-y-4" data-id="element-3389">
                <div data-id="element-3390">
                  <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3391">
                    Event Name (Internal)
                  </label>
                  <input type="text" placeholder="e.g., Saturday Night Indie Showcase" className="w-full px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500" data-id="element-3392" />
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-3393">
                  <div data-id="element-3394">
                    <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3395">
                      Date
                    </label>
                    <input type="date" className="w-full px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500" data-id="element-3396" />
                  </div>
                  <div data-id="element-3397">
                    <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3398">
                      Room
                    </label>
                    <select className="w-full px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500" data-id="element-3399">
                      <option data-id="element-3400">Main Room (400 Cap)</option>
                      <option data-id="element-3401">Side Room (80 Cap)</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-6 max-w-2xl" data-id="element-3402">
              <h2 className="text-xl font-bold text-zinc-100" data-id="element-3403">
                Booking Requirements
              </h2>
              <div className="space-y-4" data-id="element-3404">
                <div data-id="element-3405">
                  <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3406">
                    Target Genres
                  </label>
                  <input type="text" placeholder="e.g., Indie Rock, Post-Punk" className="w-full px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500" data-id="element-3407" />
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-3408">
                  <div data-id="element-3409">
                    <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3410">
                      Min Budget
                    </label>
                    <input type="number" placeholder="$500" className="w-full px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500" data-id="element-3411" />
                  </div>
                  <div data-id="element-3412">
                    <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3413">
                      Max Budget
                    </label>
                    <input type="number" placeholder="$1500" className="w-full px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500" data-id="element-3414" />
                  </div>
                </div>
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6 max-w-2xl" data-id="element-3415">
              <h2 className="text-xl font-bold text-zinc-100" data-id="element-3416">
                Operational Constraints
              </h2>
              <div className="space-y-6" data-id="element-3417">
                <div className="grid grid-cols-2 gap-4" data-id="element-3418">
                  <div data-id="element-3419">
                    <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3420">
                      Load-in Window
                    </label>
                    <div className="relative" data-id="element-3421">
                      <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" data-id="element-3422" />
                      <input type="text" placeholder="e.g., 3:00 PM - 5:00 PM" className="w-full pl-10 pr-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500" data-id="element-3423" />
                    </div>
                  </div>
                  <div data-id="element-3424">
                    <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3425">
                      Curfew
                    </label>
                    <div className="relative" data-id="element-3426">
                      <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" data-id="element-3427" />
                      <input type="time" defaultValue="02:00" className="w-full pl-10 pr-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500" data-id="element-3428" />
                    </div>
                  </div>
                </div>

                <div className="space-y-3" data-id="element-3429">
                  <label className="flex items-center space-x-3 p-3 bg-zinc-900 border border-zinc-800 rounded-lg cursor-pointer hover:border-zinc-700 transition-colors" data-id="element-3430">
                    <input type="checkbox" defaultChecked className="rounded border-zinc-700 text-amber-500 focus:ring-amber-500 bg-zinc-800 w-5 h-5" data-id="element-3431" />
                    <div className="flex items-center space-x-2" data-id="element-3432">
                      <Zap className="w-4 h-4 text-zinc-400" data-id="element-3433" />
                      <span className="text-sm font-medium text-zinc-100" data-id="element-3434">
                        In-house PA & Lighting Provided
                      </span>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-3 bg-zinc-900 border border-zinc-800 rounded-lg cursor-pointer hover:border-zinc-700 transition-colors" data-id="element-3435">
                    <input type="checkbox" className="rounded border-zinc-700 text-amber-500 focus:ring-amber-500 bg-zinc-800 w-5 h-5" data-id="element-3436" />
                    <div className="flex items-center space-x-2" data-id="element-3437">
                      <Music className="w-4 h-4 text-zinc-400" data-id="element-3438" />
                      <span className="text-sm font-medium text-zinc-100" data-id="element-3439">
                        Backline Provided (Drums, Amps)
                      </span>
                    </div>
                  </label>
                  <label className="flex items-center space-x-3 p-3 bg-zinc-900 border border-zinc-800 rounded-lg cursor-pointer hover:border-zinc-700 transition-colors" data-id="element-3440">
                    <input type="checkbox" className="rounded border-zinc-700 text-amber-500 focus:ring-amber-500 bg-zinc-800 w-5 h-5" data-id="element-3441" />
                    <div className="flex items-center space-x-2" data-id="element-3442">
                      <Home className="w-4 h-4 text-zinc-400" data-id="element-3443" />
                      <span className="text-sm font-medium text-zinc-100" data-id="element-3444">
                        Venue Lodging / Band House Available
                      </span>
                    </div>
                  </label>
                </div>

                <div data-id="element-3445">
                  <label className="block text-sm font-medium text-zinc-300 mb-1" data-id="element-3446">
                    Additional Technical Notes
                  </label>
                  <textarea rows={3} placeholder="Any specific technical requirements or venue quirks..." className="w-full px-4 py-2 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:outline-none focus:border-amber-500 resize-none" data-id="element-3447"></textarea>
                </div>
              </div>
            </div>}

          {currentStep === 4 && <div className="space-y-6" data-id="element-3448">
              <h2 className="text-xl font-bold text-zinc-100" data-id="element-3449">
                Review & Generate Matches
              </h2>
              <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6" data-id="element-3450">
                <div className="flex items-center justify-between mb-6" data-id="element-3451">
                  <div data-id="element-3452">
                    <h3 className="font-medium text-zinc-100" data-id="element-3453">
                      Saturday Night Indie Showcase
                    </h3>
                    <p className="text-sm text-zinc-400" data-id="element-3454">
                      Main Room • Jul 11, 2026
                    </p>
                  </div>
                  <div className="text-right" data-id="element-3455">
                    <div className="text-2xl font-bold text-amber-500" data-id="element-3456">~45</div>
                    <p className="text-xs text-zinc-500" data-id="element-3457">Estimated Matches</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-3458">
                  <div data-id="element-3459">
                    <span className="text-zinc-500 block" data-id="element-3460">Genres</span>
                    <span className="text-zinc-300" data-id="element-3461">Indie Rock, Post-Punk</span>
                  </div>
                  <div data-id="element-3462">
                    <span className="text-zinc-500 block" data-id="element-3463">Budget</span>
                    <span className="text-zinc-300" data-id="element-3464">$500 - $1,500</span>
                  </div>
                </div>
              </div>
            </div>}
        </div>

        {/* Navigation Buttons */}
        <div className="flex items-center justify-between mt-8 pt-6 border-t border-zinc-800" data-id="element-3465">
          <button onClick={prevStep} disabled={currentStep === 1} className="flex items-center space-x-2 px-4 py-2 text-zinc-400 hover:text-zinc-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-3466">
            <ArrowLeft className="w-4 h-4" data-id="element-3467" />
            <span data-id="element-3468">Back</span>
          </button>
          {currentStep < 4 ? <button onClick={nextStep} className="flex items-center space-x-2 px-6 py-2 bg-amber-500 hover:bg-amber-400 text-zinc-900 font-medium rounded-lg transition-colors" data-id="element-3469">
              <span data-id="element-3470">Next</span>
              <ArrowRight className="w-4 h-4" data-id="element-3471" />
            </button> : <button className="flex items-center space-x-2 px-6 py-2 bg-amber-500 hover:bg-amber-400 text-zinc-900 font-medium rounded-lg transition-colors" data-id="element-3472">
              <Users className="w-4 h-4" data-id="element-3473" />
              <span data-id="element-3474">Generate Matches</span>
            </button>}
        </div>
      </div>
    </motion.div>;
}